module.exports = __webpack_public_path__ + "static/honey-708032156171a5c2ce5b6a4833f01a89.svg";